import {Chip} from "@mui/material";
import React from "react";
import {TWO_COLOR_SHADES} from "../theme/shades";

function ColouredChip({label, type, icon, fontSize}) {

  const paintChip = (color) => {
    if (color) {
      return TWO_COLOR_SHADES[color];
    } else
      return {
        dark: "",
        light: "",
      };
  };

  return (
    <Chip
      icon={icon}
      label={label}
      sx={{
        color: paintChip(type)['dark'],
        backgroundColor: paintChip(type)['light'],
        height: 15,
        fontSize: `${fontSize}px`
      }}
    />
  );
}

export default ColouredChip;
